<template>
  <div id="IntegratedModelDetail">
    <el-drawer
        :visible.sync="showDrawer"
        direction="ltr"
        append-to-body
        size="70%"
        @close="$emit('close-draw')"
    >
      <template #title>
        <ellipsis-text :text="detailInfo.name" :show-text-count="30"></ellipsis-text>
      </template>
      <div class="detail-body">
        <div class="detail-base-info">
          <el-row class="info-row" :gutter="20">
            <el-col class="info-col" :span="8">
              <span class="label-col">发布人</span>
              <span class="value-col">{{detailInfo.creatorName}}</span>
            </el-col>
            <el-col class="info-col" :span="16">
              <span class="label-col">发布时间</span>
              <span class="value-col">{{ $fmtTime(detailInfo.createTime) }}</span>
            </el-col>
          </el-row>
        </div>
        <gjw-dimensions @height-changed="onBoxHeightChanged">
          <div class="content-container">
            <div class="fix-flex-table">
              <gjw-table
                  ref="listTable"
                  v-loading="tableLoading"
                  :columns="tableColumns"
                  :list-data="tableData"
                  :has-page="false"
                  :max-height="tableHeight"
              >
                <template #nameSlot="{ row }">
                  <span class="table-cell-content">
                    <img class="file-img" :src="getFileIcon(row.suffix)" alt="" />
                    <span>{{ `${row.fileName}.${row.suffix}` }}</span>
                  </span>
                </template>
              </gjw-table>
            </div>
          </div>
        </gjw-dimensions>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { integratedErrorCodeMap } from '../errorCodeMap'
import gjwDimensions from '@/components/lib/GjwDimensions.vue'
import EllipsisText from '@/views/file/components/EllipsisText.vue'
export default {
  name: 'IntegratedModelDetail',
  components: { EllipsisText, gjwDimensions },
  props: {
    spaceId: [String, Number],
  },
  data() {
    return {
      showDrawer: false,
      tableHeight: 0,
      tableLoading: false,
      detailId: null,
      detailInfo: {},
      tableData: [],
    }
  },
  computed: {
    tableColumns() {
      return [
        {
          type: 'slot',
          slotName: 'nameSlot',
          label: '名称',
          prop: 'name',
          minWidth: '240px',
        },
        {
          label: '类型',
          showOverflowTooltip: false,
          prop: 'fileType',
          minWidth: '80px',
        },
        {
          label: '版本',
          showOverflowTooltip: false,
          prop: 'version',
          minWidth: '80px',
        },
      ]
    },
    getFileIcon() {
      return (type) => require(`@/assets/file/${type || 'default'}.png`)
    },
  },
  methods: {
    onBoxHeightChanged({ newValue }) {
      this.tableHeight = newValue
    },
    openDrawer(row) {
      this.showDrawer = true
      this.detailId = row.id
      this.getDetail()
    },
    closeDrawer() {
      this.showDrawer = false
    },
    // 获取模型详情
    getDetail() {
      this.tableLoading = true
      this.$api.file.integratedModelInfo(this.spaceId, this.detailId).then((data) => {
        this.detailInfo = data || {}
        this.tableData = data.fileItems || []
      }).catch((err) => {
        this.$matchError(err.code, integratedErrorCodeMap, '获取交付模型详情失败')
        this.closeDrawer()
      }).finally(() => {
        this.tableLoading = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
.detail-body{
  padding: 0 24px;
  height: 100%;
}
.detail-base-info{
  padding-top: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid @border-color;
  .info-row{
    margin-bottom: 20px;
  }
  .info-col{
    display: flex;
    flex-direction: row;
  }
  .label-col{
    flex: 0 0 60px;
    font-weight: 600;
    margin-right: 20px;
  }
  .value-col{
    flex: 1;
  }
}
.content-container{
  margin-top: 16px;
  position: relative;
  height: calc(100% - 180px);
}
.file-img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 6px;
}
/deep/ .ft-red.el-button--text:focus, .ft-red.el-button--text:hover{
  color: @error-color;
}
</style>
